window.addEventListener('load', function () {
	//Initialize navigation
	if (document.querySelector('nav.mainNavigation')) {
	}
	navigation();
	$$ash.metaNavInit(
		'.secondaryInfo .user-info a.dropdown-menu-trigger',
		'.secondaryInfo .user-info .dropdown-menu-cont'
	);

	//set up ashModal
	setupAshModal($('.modalOpen'));
});
